module.exports = __webpack_public_path__ + "img/3.6558c297.webp";